<script>
import { mapState } from 'vuex';

export default {
    name: "Footer",
    data() {
        return {};
    },
    computed: {
        ...mapState(['nav', 'isLogin', 'userinfo'])
    },
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="footer">
        <div class="wrapper layout_main flex justify_between">
            <div class="item">
                <div class="name">Quick links</div>
                <div class="list nav">
                    <div class="item" v-for="(item, index) in nav" :key="index">
                        <router-link :to="item.link">{{ item.name }}</router-link>
                    </div>
                    <div class="item">
                        <!-- login -->
                        <router-link v-if="!isLogin" to="/login">Student Login</router-link>
                        <router-link v-else to="/mine">{{ userinfo.email }}</router-link>
                    </div>
                </div>
            </div>
            <div class="item">
                <div class="name">STAY CONNECTED</div>
                <div class="list flex flex_column">
                    <div class="item">
                        <span>Whatsapp:  07873693102</span>
                    </div>
                    <div class="item">
                        <a href="tel:+44(0)2030093414">Phonecall:  +44 (0) 2030093414</a>
                    </div>
                    <div class="item">
                        <a href="mailto:info@oaluk.com">Email: info@oaluk.com</a>
                    </div>
                </div>
            </div>
            <div class="item">
                <div class="name">GET IN TOUCH</div>
                <div class="list flex flex_column">
                    <div class="item">
                        <span>Add: 63 ST MARY AXE, LONDON</span>
                    </div>
                    <div class="item">
                        <span>EC3A 8AA</span>
                    </div>
                    <div class="item">
                        <a href="tel:+44(0)2030093414">Tel: +44 (0) 2030093414</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="beian">© Registered in England | Oxbridge Academy London | All rights reserved</div>
    </div>
</template>

<style scoped lang="scss">
.footer{
    background: var(--background-color);
    .wrapper{
        padding: 1rem 0 1.2rem;
        font-size: .16rem;
        @media only screen and (max-width: 750px) {
            padding: .8rem 0;
            font-size: .2rem;
            flex-direction: column;
            gap: .8rem;
        }
        >.item{
            .name{
                font-weight: 600;
                color: var(--color-blue);
                text-transform: uppercase;
                margin-bottom: .2rem;
                @media only screen and (max-width: 750px) {
                    white-space: nowrap;
                    display: flex;
                    align-items: center;
                    &::after{
                        content: "";
                        display: block;
                        flex: 1;
                        border-bottom: 1px solid var(--color-blue);
                        margin-left: .2rem;
                    }
                }
            }
            .list{
                color: #fff;
                white-space: nowrap;
                gap: .2rem;
                &.nav{
                    column-count: 2;
                    column-gap: .5rem;
                    margin-bottom: -.2rem;
                    .item{
                        margin-bottom: .2rem;
                    }
                    @media only screen and (max-width: 750px) {
                        column-count: 3;
                    }
                }
                .item{
                    @media only screen and (max-width: 750px) {
                        flex: 1;
                    }
                    span,
                    a{
                        border-bottom: 1px solid #fff;
                    }
                }
            }
        }
    }
    .beian{
        font-size: .12rem;
        text-align: center;
        line-height: .32rem;
        color: #fff;
        background: #0e0e24;
        font-weight: normal;
    }
}
</style>